import { propertyFetch } from './property-api'
import type { PropertyHeroSlideAccent, PropertyHeroSlideIconKey, PropertyHeroSlideRecord } from './property-hero-slides'

export type PropertyAdBannerAccent = PropertyHeroSlideAccent
export type PropertyAdBannerIconKey = PropertyHeroSlideIconKey
export type PropertyAdBannerRecord = PropertyHeroSlideRecord

export async function loadPropertyAdBanners() {
  const { items } = await propertyFetch<{ items: PropertyAdBannerRecord[] }>('/v1/property/ad-banners', { public: true })
  return items.filter(item => item.isActive && item.actionLabel && (item.renderMode === 'canvas' ? item.title && item.description : item.imageUrl))
    .map(item => ({ ...item, order: Number(item.order) || 1 }))
    .sort((a, b) => a.order - b.order || a.title.localeCompare(b.title))
}
